module.exports = __webpack_public_path__ + "static/media/jay.5f4e2174.jpg";